import React from 'react';
import '../App.css';

function About() {
    return (
      <>
        <h1 className="about-hero">WHAT ABOUT IT?</h1>
        <div className="about-spacing">
          <h2 className="about-text">I'M A DESIGNER. I LIKE DESIGNING AND BUILDING NEW THINGS. I TAKE PRODUCTS FROM ZERO TO BEAUTIFULLY DESIGNED USER-READY INTERFACES. MY DESIGN PHILISOPHY IS BASED AROUND THE IDEA THAT SIMPLICITY IS THE ULTIMATE SOPHISTICATION. A SIMPLE USER INTERFACE WITH A COMPLEX BACKEND DESIGN HIDDEN FROM VIEW, CREATES EXPERIENCES BEYOND THE IMAGINABLE. REACH OUT TO ME TO LEARN MORE ABOUT MY WORK, AND HOW WE MAY COLLABORATE.</h2>
          <h2 className="about-text">PORTFOLIO:</h2>
          <h2 className="about-text"><a href="https://elyah.io">- ELYAH: QUANTUM COMPUTING REDESIGNED</a></h2>
          <h2 className="about-text"><a href="https://sellou.com">- SELLOU: TAG WHAT YOU LOVE</a></h2>
          <h2 className="about-text">- SWLF:سوالف</h2>
          <h6>E-MAIL ME AT SAL@SELLOU.COM</h6>
          <h6 class="about-small">AND YES, THIS IS BY DESIGN. WHAT FUN IS IT IF THE EMAIL WAS AS BIG AS THE FONT ABOVE? IT'S A LOT FUNNER TO MAKE EVERYONE LOOK A LITTLE CLOSER.</h6>
        </div>
      </>
      )
}

export default About;
